
import React from "react";
import { motion } from "framer-motion";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";

const Home = () => {
  return (
    <div>
      {/* Hero Section */}
      <section className="hero-section relative h-[60vh] flex items-center justify-center text-white">
        <img 
          className="absolute inset-0 w-full h-full object-cover"
          alt="Vista panorámica de la Urbanización El Coto"
          src="https://storage.googleapis.com/hostinger-horizons-assets-prod/bf70a780-c63d-4c1f-a917-3f646f017aeb/4b261125a43e68e943b6c05c36985e5c.jpg" />
        <div className="absolute inset-0 bg-black/50" />
        <div className="relative z-10 text-center px-4">
          <motion.h1
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="text-4xl md:text-6xl font-bold mb-4"
          >
            Candidatura a las Elecciones de la Urbanización El Coto del 30 de Marzo
          </motion.h1>
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2 }}
            className="text-xl md:text-2xl mb-8"
          >
            Construyendo el futuro de nuestra comunidad
          </motion.p>
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.4 }}
          >
            <Link to="/equipo">
              <Button size="lg" className="mr-4">
                Conoce al Equipo
              </Button>
            </Link>
            <Link to="/planes">
              <Button size="lg" variant="outline">
                Nuestros Planes
              </Button>
            </Link>
          </motion.div>
        </div>
      </section>

      {/* Features Section */}
      <section className="py-16 px-4 bg-gray-50">
        <div className="max-w-7xl mx-auto">
          <h2 className="text-3xl font-bold text-center mb-12 text-primary">
            Nuestro Compromiso
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              className="text-center p-6 rounded-lg shadow-lg bg-white/90 backdrop-blur-sm"
            >
              <h3 className="text-xl font-semibold mb-4 text-primary">Transparencia</h3>
              <p className="text-gray-800">
                Gestión clara y comunicación abierta con todos los vecinos
              </p>
            </motion.div>
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: 0.2 }}
              className="text-center p-6 rounded-lg shadow-lg bg-white/90 backdrop-blur-sm"
            >
              <h3 className="text-xl font-semibold mb-4 text-primary">Eficiencia</h3>
              <p className="text-gray-800">
                Optimización de recursos y mejora continua de servicios
              </p>
            </motion.div>
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: 0.4 }}
              className="text-center p-6 rounded-lg shadow-lg bg-white/90 backdrop-blur-sm"
            >
              <h3 className="text-xl font-semibold mb-4 text-primary">Comunidad</h3>
              <p className="text-gray-800">
                Fomentando la participación y el bienestar de todos los vecinos
              </p>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="bg-primary text-white py-16 px-4">
        <div className="max-w-7xl mx-auto text-center">
          <h2 className="text-3xl font-bold mb-4">
            Únete a nuestro proyecto de futuro
          </h2>
          <p className="text-xl mb-8">
            Juntos podemos hacer de El Coto un lugar mejor para todos
          </p>
          <Link to="/participar">
            <Button size="lg" variant="outline" className="text-white border-white hover:bg-white hover:text-primary">
              Contacta con nosotros
            </Button>
          </Link>
        </div>
      </section>
    </div>
  );
};

export default Home;
